module.exports = __webpack_public_path__ + "static/bg.af733eb7.png";